import type { NextPage } from "next";
import PageLayout from "@components/PageLayout";

import useLedgerCookies from "@hooks/useLedgerCookies";

import ClaimEL from "@components/ClaimELV2";

const ClaimELPage: NextPage = () => {
  useLedgerCookies();
  return (
    <PageLayout extraMarginTop={false}>
      <ClaimEL />
    </PageLayout>
  );
};

export default ClaimELPage;
